module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nice-selectfield",
    attrs: {
      "id": 'multiselect-' + _vm.uniq
    }
  }, [_c('button', {
    ref: "button",
    staticClass: "nice-select",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("\n    " + _vm._s(_vm.visibleValue)), _c('span', [_vm._v("▾")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a46d8cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/MultiSelect.vue
// module id = 436
// module chunks = 0